import axios from 'axios';

// filetypes: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types

/* Slouží ke stažení dokumentu v rámci ISB služeb */
const fileDownload = (
    fileType: 'pdf' | 'xml' | 'zip' | 'html',
    token: String,
    typ: 'vypis' | 'faktura'
    // fileName?: string
) => {
    return axios({
        method: 'GET',
        url: `/NZ/zadost/DownloadPDF?typ=${typ}`,
        headers: {
            Authorization: `Bearer ${token}`
        },
        responseType: 'blob' // important
    }).then(resp => {
        if (resp.status === 200) {
            let fileName = '';

            if (typ === 'vypis') {
                fileName = 'Výpis z nezařazeného účtu';
            } else if (typ === 'faktura') {
                fileName = 'Faktura';
            } // TODO: Predelat na nejakej lepsi zpusob... rn nevim jak to s tim typem bude :D

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // IE
                window.navigator.msSaveOrOpenBlob(resp.data, fileName);
            } else {
                const odp = resp.data;
                const uriContent = URL.createObjectURL(
                    new Blob([odp], {
                        type: `application/${fileType}`
                    })
                );
                const link = document.createElement('a');
                link.style.display = 'none';
                // link.download = fileName || 'Výpis z nezařazeného účtu';
                link.download = fileName || 'pdf';
                link.href = uriContent;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    });
};

export default fileDownload;
